import { SceneManager } from './core/managers/SceneManager';
import { CoreController } from './core/CoreController';
import { Loader } from './Loader';
import { WindowManager } from './core/managers/WindowManager';
import { PopUpManager } from './core/managers/PopUpManager';
import { SettingsManager } from './core/managers/SettingsManager';
import { GameAnalytics } from './analytics/GameAnalytics';
import { StoryProgressManager } from './core/managers/saveData/StoryProgressManager';
import { SoundManager } from './core/managers/SoundManager';
import { IAPManager } from './core/managers/IAPManager';
import { AvatarManager } from './core/managers/AvatarManager';
import { AnalyticsEventNames } from './analytics/AnalyticsEventNames';
import { FacebookManager } from './core/managers/facebook/FacebookManager';
import { GDManager } from './core/managers/gameDistribution/GDManager';

namespace EntryPoint {
    const startTime: number = Date.now();
    let app: Application;

    import Application = PIXI.Application;

    export function boot(managerClass: any): void {
        app = startRenderer();
        /* tslint:disable-next-line */
        const font: FontFaceObserver = new FontFaceObserver('Coiny');
        font.load().then((): void => {
            const font2: FontFaceObserver = new FontFaceObserver('Chewy');
            font2.load().then((): void => {
                preload(managerClass);
            });
        });
    }

    function startRenderer(): Application {
        return SceneManager.getInstance()._app;
    }

    function preload(managerClass: any): void {
        Loader.getInstance().loadInitialAssets((): any => {
            onLoaded(managerClass);
        }, managerClass);
        // StoryProgressManager.getInstance().getLastSolvedLevel().then((lastSolvedLevel: number): void => {
        //
        // });
    }

    function onLoaded(managerClass: any): void {
        managerClass.getInstance().startGameAsync().then(() => {
            startApplication(managerClass);
        });
        logLoadingTime();
    }

    function logLoadingTime(): void {
        const endTime: number = Date.now();
        const timeDiff: number = endTime - startTime;

        // get seconds
        const seconds: number = Math.round(timeDiff);
        // TODO: LOG LOADING TIME
        // FBInstant.logEvent(
        //     'loading_time',
        //     seconds
        // );
    }

    function logBootTime(): void {
        const endTime: number = Date.now();
        const timeDiff: number = endTime - startTime;

        // get seconds
        const seconds: number = Math.round(timeDiff);
        // TODO: LOG BOOT TIME
        // FBInstant.logEvent(
        //     'boot_time',
        //     seconds
        // );
    }

    function startApplication(managerClass: any): void {
        logBootTime();
        if (managerClass === FacebookManager) {
            const gameAnalytics: GameAnalytics = GameAnalytics.getInstance();
            const iapManager: IAPManager = IAPManager.getInstance();
            const avatarManager: AvatarManager = AvatarManager.getInstance();
        }
        const windowManager: WindowManager = WindowManager.getInstance();
        const popUpManager: PopUpManager = PopUpManager.getInstance();
        StoryProgressManager.getInstance().init(managerClass).then((): void => {
            // @ts-ignore-next-line
            CoreController.getInstance().init(window.DEV_MODE, managerClass).then((): void => {
                const settingsManager: SettingsManager = SettingsManager.getInstance();
                CoreController.getInstance().adManager.getInstance().init().then((): void => {
                    const soundManager: SoundManager = SoundManager.getInstance();
                    if (!CoreController.getInstance().isDevMode()) {
                        if (managerClass === FacebookManager) {
                            const contextType: any = FBInstant.context.getType();
                            GameAnalytics.getInstance().logDesign(AnalyticsEventNames.context_type, false, false, null, contextType);
                            CoreController.getInstance().adManager.getInstance().preloadRewardedAd(1);
                        }
                        StoryProgressManager.getInstance().getNumberOfSessions().then((result: number) => {
                            if (result >= 2 && !managerClass.getInstance().hasNoAdsPass()) {
                                // FBAdManager.getInstance().preloadInterstitialAd(1);
                            }
                        });
                    }
                });
            });
        });
    }
}

window.onload = (): void => {
    let manager: any;
    /* tslint:disable-next-line */
    const environment: string = window['loadingData'].platform;
    if (environment === 'FB') {
        manager = FacebookManager;
    } else if (environment === 'GD') {
        manager = GDManager;
    }
    manager.getInstance().initializeAsync().then(() => {
        console.clear();
        EntryPoint.boot(manager);
        /* tslint:disable-next-line */
        const loadingData: any = window['loadingData'];

        // @ts-ignore
        window.DEV_MODE = loadingData.debugMode;
    });
};